module.exports = __webpack_public_path__ + "56c1ee8a9f49b39730d9de640efb1c1d.png";